import { render, staticRenderFns } from "./YearTitleBar.vue?vue&type=template&id=33985c95&"
import script from "./YearTitleBar.vue?vue&type=script&lang=js&"
export * from "./YearTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports